import {useLocation} from "react-router-dom";
import {Post} from "../../common/types/post.types";
import {getSinglePost, generateBreadcrumbsForPost} from "../../utils/post-utils";
import {PostType} from "../../common/enums/post.enum";
import Series from "./series";
import SimplePost from "./simple-post";
import '../../sass/post.scss';
import Breadcrumbs from "../common/breadcrumb";
import {BreadCrumbContent} from "../../common/types/common.types";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function PostDetail() {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadCrumbContent[]>();
  const [post, setPost] = useState<Post>(null);
  const location = useLocation();
  const sections = useSelector((state: any) => state.sections.data);
  const sectionPaths = location.pathname.split('/');
  // Remove first and second element is the empty string and the indicator of large component
  sectionPaths.shift();
  sectionPaths.shift();

  const postId = sectionPaths[sectionPaths.length - 1];

  useEffect(() => {
    getSinglePost(parseInt(postId)).then(data => {
      setPost(data)
    });
  }, [])

  useEffect(() => {
    if (post && sections) {
      const subSections = Object.values(post.sections).map(item => item.path);
      setBreadcrumbs(generateBreadcrumbsForPost(subSections, sections));
    }
  }, [sections, post]);

  if (!post) {
    return <div></div>;
  }

  if (post.post_type === PostType.series) {
    return (
      <div className={'post-detail'}>
        <Breadcrumbs data={breadcrumbs}/>
        <div className={'series-post'}>
          <Series post={post}/>
        </div>
      </div>
    )
  } else {
    return (
      <div className={'post-detail'}>
        <Breadcrumbs data={breadcrumbs}/>
        <div className={'simple-post'}>
          <div className={'container'}>
            <SimplePost post={post}/>
          </div>
        </div>
      </div>
    )
  }
}

export default PostDetail;
